import { useEffect, useRef } from "react";

/**
 * Runs `effect` exactly once after mount — even under React.StrictMode, which
 * intentionally double-invokes effects in development. Use this for
 * "load on mount" data fetches so the request doesn't fire twice.
 *
 * The guard ref persists across StrictMode's simulated unmount/remount (it's the
 * same component instance), so the second invocation is reliably skipped.
 * If `effect` returns a cleanup function it is registered as usual.
 */
export default function useEffectOnce(effect) {
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const cleanup = effect();
    return typeof cleanup === "function" ? cleanup : undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
